import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Link from 'next/link';
import { classnames } from '@@client/lib/classes';
export default function PrivacyTermsBrief(_ref) {
  var className = _ref.className;
  var classNames = classnames([className, 'm--size--smaller', 'm--gray--medium']);
  return /*#__PURE__*/_jsxs("p", {
    className: classNames,
    children: ["By continuing you agree to Autowrecking.com\u2019s ", /*#__PURE__*/_jsx(Link, {
      href: "/legal/privacy",
      children: /*#__PURE__*/_jsx("a", {
        children: "Privacy Policy"
      })
    }), " and ", /*#__PURE__*/_jsx(Link, {
      href: "/legal/terms",
      children: /*#__PURE__*/_jsx("a", {
        children: "Terms & Conditions"
      })
    }), "."]
  });
}